export default "__VITE_ASSET__k3urIfn6__"